import React from 'react';
import { Redirect, Route, Switch } from 'wouter';
import { UseLocationScope } from '../../AppLocation';
import { AdminNavigationView } from '../../account/navigation/AdminNavigationView';
import { Page2 } from '../../common/Page2';
import { usePermissionCheck } from '../../common/PermissionElements';
import { AccountInfoView } from './AccountInfoView';
import { ManageAccountAccessView } from './ManageAccountAccessView';
import { ManageActivityLogsView } from './ManageActivityLogsView';
import { ManageDangerZoneView } from './ManageDangerZoneView';
import { ManageLegacyBillingView } from './ManageLegacyBillingView';
import { ManageTeamDetailsView } from './ManageTeamDetailsView';
import { ManageAIView } from './ai/ManageAIView';
import { ManageBoardsView } from './boards/ManageBoardsView';
import { ManagePeopleView } from './people/ManagePeopleView';
import { ManageLegacySingleSignOnView } from './sso/ManageLegacySingleSignOnView';
import { ManageSingleSignOnSwitch } from './sso/ManageSingleSignOnSwitch';
import { ManageSingleSignOnView } from './sso/ManageSingleSignOnView';
import { SetupSingleSignOnView } from './sso/SetupSingleSignOnView';
import { ManageTeamsView } from './teams/ManageTeamsView';

export const NewManagementPage = () => {

    const canAdmin = usePermissionCheck('ac_team:read');
    if (!canAdmin) return <Redirect to="~/" />;

    return <Page2 navigation={AdminNavigationView}>
        <UseLocationScope name="manage" label="Manage" />
        <Page2.Scroll>
            <Switch>
                <Route path="/info" component={AccountInfoView} />
                <Route path="/people" component={ManagePeopleView} />
                <Route path="/teams/:teamId" component={ManageTeamDetailsView} />
                <Route path="/teams" component={ManageTeamsView} />
                <Route path="/boards" component={ManageBoardsView} />
                <Route path="/activity" component={ManageActivityLogsView} />
                <Route path="/access" component={ManageAccountAccessView} />
                <Route path="/sso/setup/:provider" component={SetupSingleSignOnView} />
                <Route path="/sso/setup" component={SetupSingleSignOnView} />
                <Route path="/sso/v2" component={ManageSingleSignOnView} />
                <Route path="/sso/v1" component={ManageLegacySingleSignOnView} />
                <Route path="/sso" component={ManageSingleSignOnSwitch} />
                <Route path="/ai" component={ManageAIView} />
                <Route path="/danger" component={ManageDangerZoneView} />
                <Route path="/billing/:param?" component={ManageLegacyBillingView} />
                <Route path="*" component={() => <Redirect to="~/manage/info" />} />
            </Switch>
        </Page2.Scroll>
    </Page2>;
};
